import React, { useState, useEffect, useRef } from "react";
import Nav from "./Navigation.js";

function Reveal({ children, className = "" }) {
  const ref = useRef(null);
  const [visible, setVisible] = useState(false);

  useEffect(() => {
    const el = ref.current;
    if (!el) return;
    const observer = new IntersectionObserver(
      ([entry]) => {
        if (entry.isIntersecting) {
          setVisible(true);
          observer.unobserve(el);
        }
      },
      { threshold: 0.15 }
    );
    observer.observe(el);
    return () => observer.disconnect();
  }, []);

  return (
    <div
      ref={ref}
      className={`transition-all duration-700 ease-out ${
        visible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-6"
      } ${className}`}
    >
      {children}
    </div>
  );
}

const monstersData = [
  {
    id: 1,
    name: "Archiver",
    imagePath: "Archiver.PNG",
    aka: "Archie, Johnny 5",
    locations: ["BackRooms", "Fog City"],
    hint: "Run! they cannot catch you on speed alone, if you can take turns around corners. If they lose sight of, they well lose aggro on you"
  },
  {
    id: 3,
    name: "Black Bride",
    imagePath: "BlackBride.PNG",
    aka: "Black Bride",
    locations: ["Castle", "Manor", "Snowy Hedges"],
    hint: "Run! You can outrun them, but they go through walls, so try to keep a straight line or take turns and keep moving so they do not catch you"
  },
  {
    id: 6,
    name: "Centipede",
    imagePath: "Centipede.PNG",
    aka: "BUG",
    locations: ["Sewers"],
    hint: "Travel on the side walls be careful of the antenna! This monster will travel in the middle of the pathway so stick to the sides. Watch for antenna sticking out of the ground, they dig underground and wait for you walk over them!"
  },
  {
    id: 7,
    name: "Clarice",
    imagePath: "Clarice.PNG",
    aka: "'Dammit Clarice'",
    locations: ["Unkept Hedges"],
    hint: "There is no counter! Save your soul"
  },
  {
    id: 8,
    name: "Clown",
    imagePath: "Clown.PNG",
    aka: "Clown",
    locations: ["Carnival"],
    hint: "Run! They are faster than you. So try to get as much distance while they laugh. Also makes it easier to lose them if you turn corners and they lose line of sight"
  },
  {
    id: 9,
    name: "Clubfoot",
    imagePath: "Clubfoot.PNG",
    aka: "ShyGuy",
    locations: [
      "Bamboo Forest",
      "Corn Field",
      "Dead Forest",
      "Forest",
      "Kept Hedges",
      "Manor",
      "Ruins",
      "Sewers",
      "Snowy Hedges",
      "Swamp",
      "Trenches",
      "Unkept Hedges",
    ],
    hint: "Do not look at him. He wont like it and will run you down!. If you happen to look at him, try and get as much distance as possible. He has a limited distance he can run at you!"
  },
  {
    id: 16,
    name: "Club Foot-Frost",
    imagePath: "FrostFoot.PNG",
    aka: "Frost Foot",
    locations: ["Snowy Hedges"],
    hint: "Do not look at him. He wont like it and will run you down!. If you happen to look at him, try and get as much distance as possible. He has a limited distance he can run at you!"
  },
  {
    id: 10,
    name: "Creep",
    imagePath: "Creep.PNG",
    aka: "Alien",
    locations: ["Crypt", "Snowy Hedges", "Ruins"],
    hint: "It will run after you forever, it is matched in speeed, but if you can take tight corners, you may be able to lose it. If it catches someone, it glows red and there is no escape anymore, avoid being seen!"
  },
  {
    id: 11,
    name: "Crimson Lady",
    imagePath: "CrimsonLady.PNG",
    aka: "Crimson Bride",
    locations: ["Castle", "Crypt", "Manor", "Mines", "Snowy Hedges"],
    hint: "Run! You can outrun them, but they go through walls, so try to keep a straight line or take turns and keep moving so they do not catch you"
  },
  {
    id: 12,
    name: "Crocodile",
    imagePath: "Crocodile.PNG",
    aka: "Gator Golf",
    locations: ["Swamp"],
    hint: "Stay out of the water! You can spend limited time, listen for the growl, means it is near! get on some debris or back on the docks!"
  },
  {
    id: 14,
    name: "Crypt Zombie",
    imagePath: "CryptZombie.PNG",
    aka: "Crypt Zombie",
    locations: [
      "BackRooms",
      "Castle",
      "Crypt",
      "Dead Forest",
      "Manor",
      "Snowy Hedges",
    ],
    hint: "Do not use light in its presence, it will trigger them and they will run after you. You can outrun them. Listen for their sound, will let you know to turn off your lights"
  },
  {
    id: 4,
    name: "Crypt Zombie Bloody",
    imagePath: "BloodyCryptZombie.PNG",
    aka: "Crypt Zombie",
    locations: [
      "BackRooms",
      "Castle",
      "Crypt",
      "Dead Forest",
      "Manor",
      "Snowy Hedges",
    ],
    hint: "Do not use light in its presence, it will trigger them and they will run after you. You can outrun them. Listen for their sound, will let you know to turn off your lights"
  },
  {
    id: 5,
    name: "Crypt Zombie Burnt",
    imagePath: "BurntCryptZombie.PNG",
    aka: "Crypt Zombie",
    locations: [
      "BackRooms",
      "Castle",
      "Crypt",
      "Dead Forest",
      "Manor",
      "Snowy Hedges",
    ],
    hint: "Do not use light in its presence, it will trigger them and they will run after you. You can outrun them. Listen for their sound, will let you know to turn off your lights"
  },
  {
    id: 15,
    name: "Feeler",
    imagePath: "Feeler.PNG",
    aka: "LickyTongue",
    locations: [
      "Corn Field",
      "Forest",
      "Kept Hedges",
      "Swamp",
      "Unkept Hedges",
    ],
    hint: "They have tentacles that reach out. Once they attach to you, they can and will catch you if you do not find safe haven. Avoid the reach of their tongue"
  },
  {
    id: 19,
    name: "Leech",
    imagePath: "Leech.PNG",
    aka: "Leech",
    locations: ["Dead Forest", "Forest"],
    hint: "Listen for them, and run. They are persistent in their chase but easy enough to get around"
  },
  {
    id: 21,
    name: "Marionette",
    imagePath: "Marionette.PNG",
    aka: "Marionette",
    locations: ["Carnival"],
    hint: "Run! They match you in speed, so avoid dead ends, if you can make enough turns or have them run into/through debris it will slow them down!"
  },
  {
    id: 22,
    name: "Miner",
    imagePath: "Miner.PNG",
    aka: "Miner",
    locations: ["Mines"],
    hint: "If you see the Miners light, turn off your light, it will attract them. They also have a lower chance of going down a dead end, so you can use that to your advantage"
  },
  {
    id: 23,
    name: "Mosquito",
    imagePath: "Mosquito.PNG",
    aka: "Fuckin Bug",
    locations: ["Dead Forest", "Forest", "Kept Hedges", "Swamp"],
    hint: "It drop down in attack mode, use your flashlight to blind it and push them away. You can increase your chances by moving around or away from them as you do!"
  },
  {
    id: 24,
    name: "Nameless",
    imagePath: "Nameless.PNG",
    aka: "PyramidHead, Chainsaw",
    locations: ["Fog City"],
    hint: "Run. It is much slower than you, but it is instant death if it catches you. You can also lop Nameless. Hug the side wall, as it gets closer to you and the wall, make your move to the other side of the wall to get by them!"
  },
  {
    id: 2,
    name: "Oni Ash varient",
    imagePath: "AshOni.PNG",
    aka: "Ash Oni, Daddy Oni",
    locations: [
      "Bamboo Forest",
      "Dead Forest",
      "Kept Hedges",
      "Snowy Hedges",
      "Swamp",
      "Unkept Hedges",
    ],
    hint: "Run! It has same speed as you, so you can run from it indefinitely!"
  },
  {
    id: 33,
    name: "Oni Red varient",
    imagePath: "RedOni.PNG",
    aka: "Red Oni, Daddy Oni Red",
    locations: ["Bamboo Forest"],
    hint: "You can not outrun this varient. So try your best to find safe haven or find the Enchanted protection and activate it to survive"
  },
  {
    id: 25,
    name: "Party Goer",
    imagePath: "PartyGoer.PNG",
    aka: "Blue Gumby",
    locations: ["Back Rooms"],
    hint: "Run away, they are slightly faster than you, but they have a super limited range for their burst of speed."
  },
  {
    id: 26,
    name: "Party Goer Cyan",
    imagePath: "PartyGoerCyan.PNG",
    aka: "Cyan Gumby",
    locations: ["Back Rooms"],
    hint: "Run away, they are slightly faster than you, but they have a super limited range for their burst of speed."
  },
  {
    id: 27,
    name: "Party Goer Green",
    imagePath: "PartyGoerGreen.PNG",
    aka: "Green Gumby",
    locations: ["Back Rooms"],
    hint: "Run away, they are slightly faster than you, but they have a super limited range for their burst of speed."
  },
  {
    id: 28,
    name: "Party Goer Pink",
    imagePath: "PartyGoerPink.PNG",
    aka: "Pink Gumby",
    locations: ["Back Rooms"],
    hint: "Run away, they are slightly faster than you, but they have a super limited range for their burst of speed."
  },
  {
    id: 29,
    name: "Party Goer Yellow",
    imagePath: "PartyGoerYellow.PNG",
    aka: "Yellow Gumby",
    locations: ["Back Rooms"],
    hint: "Run away, they are slightly faster than you, but they have a super limited range for their burst of speed."
  },
  {
    id: 31,
    name: "Pigman V2",
    imagePath: "PigmanV2.PNG",
    aka: "Bacon",
    locations: [
      "Corn Field",
      "Crypt",
      "Dead Forest",
      "Mines",
      "Sewers",
      "Snowy Hedges",
    ],
    hint: "You need to move away from it till it dashes! Then you dodge to the side and it will send it bye bye until it runs into a wall"
  },
  {
    id: 17,
    name: "Pigman Hunter varient",
    imagePath: "HunterPigman.PNG",
    aka: "Burnt Bacon, Carbon Pig",
    locations: [
      "Bamboo Forest",
      "Corn Field",
      "Crypt",
      "Dead Forest",
      "Forest",
      "Kept Hedges",
      "Mines",
      "Ruins",
      "Sewers",
      "Snowy Hedges",
      "Swamp",
    ],
    hint: "This variant is MUCH faster and harder to dodge. Listen for its music to know how to avoid it seeing you. You need to move away from it till it dashes! Then you dodge to the side and it will send it bye bye until it runs into a wall"
  },
  {
    id: 32,
    name: "Rat",
    imagePath: "Rat.PNG",
    aka: "Rat",
    locations: ["Brick Maze", "Castle", "Crypt", "Sewers", "Swamp"],
    hint: "Crouch or do not move to avoid triggering them. If you do trigger them, move away from them until they dash, then move to the side and they will run past you and bash against the wall."
  },
  {
    id: 34,
    name: "Scarecorow",
    imagePath: "ScareCrow.PNG",
    aka: "T-800, Terminator",
    locations: ["Corn Field"],
    hint: "Run forever! It will not stop, it will not rest till it catches you. Find a safe house or avoid dead ends!"
  },
  {
    id: 37,
    name: "Smiley",
    imagePath: "SmileyV2.PNG",
    aka: "Smiley",
    locations: [
      "Corn Field",
      "Crypt",
      "Forest",
      "Kept Hedges",
      "Manor",
      "Ruins",
      "Sewers",
      "Snowy Hedges",
      "Unkept Hedges",
    ],
    hint: "Do not move in its presence. If you do it will trigger its cackle/laugh. If you move after it laughs, it will run you down! If it is pathing to you, you can always move once to 'trigger' its laugh and it might change direction"
  },
  {
    id: 18,
    name: "Joker Smiley",
    imagePath: "JokerSmiley.PNG",
    aka: "Joker Smiley",
    locations: ["Carnival"],
    hint: "Do not move in its presence. If you do it will trigger its cackle/laugh. If you move after it laughs, it will run you down! If it is pathing to you, you can always move once to 'trigger' its laugh and it might change direction"
  },
  {
    id: 39,
    name: "Swamp Dog",
    imagePath: "SwampDog.PNG",
    aka: "Swamp Dog",
    locations: ["Story Mode"],
    hint: "Avoid its line of sight! You can run and hide in cabins",
    source: "story"
  },
  {
    id: 20,
    name: "Swamp Dog Mom",
    imagePath: "MamaSwampDog.PNG",
    aka: "Mama Swamp Dog",
    locations: ["Story Mode"],
    hint: "Avoid its line of sight!",
    source: "story"
  },
  {
    id: 40,
    name: "Trench Stalker",
    imagePath: "TrenchStalker.PNG",
    aka: "Edward Scissor Hands, Trenchie",
    locations: ["Crypt", "Dead Forest", "Fog City", "Snowy Hedges", "Trenches"],
    hint: "Move away from it and be ready to dodge when it sprints at you. It will miss and get stuck in a wall. Make turns often if trapped in a small area"
  },
  {
    id: 13,
    name: "Crypt Stalker",
    imagePath: "CryptStalkerWhite.PNG",
    aka: "Edward Scissor Hands, Trenchie",
    locations: ["Crypt", "Snowy Hedges"],
    hint: "Move away from it and be ready to dodge when it sprints at you. It will miss and get stuck in a wall. Make turns often if trapped in a small area"
  },
  {
    id: 41,
    name: "Vampire",
    imagePath: "Vampire.PNG",
    aka: "BatBoy",
    locations: ["Castle", "Crypt", "Ruins"],
    hint: "As it triggers for the firs time, run straight at it, it will teleport behind you. It matches you in speed so keep running, but keep an eye on it bc it can and will teleport again, and you would be best to change directions by running at it"
  },
  {
    id: 43,
    name: "Wickerman V2",
    imagePath: "WickermanV2.PNG",
    aka: "Groot, Tree",
    locations: [
      "Bamboo Forest",
      "Corn Field",
      "Forest",
      "Kept Hedges",
      "Snowy Hedges",
      "Unkept Hedges",
    ],
    hint: "Run! it is faster than you. Find a fire source or a safe room , bc it will run you down."
  },
  {
    id: 38,
    name: "Wickerman-Smolder",
    imagePath: "SmolderWickerman.PNG",
    aka: "Charcoal Groot",
    locations: ["Bamboo Forest", "Dead Forest", "Forest", "Swamp"],
    hint: "You can outrun this variant, but it is not afraid of fire, so keep running, avoid dead ends or find a safe room"
  },
  {
    id: 45,
    name: "Witch",
    imagePath: "Witch.PNG",
    aka: "Witch Bitch",
    locations: [
      "Corn Field",
      "Dead Forest",
      "Forest",
      "Kept Hedges",
      "Manor",
      "Sewers",
      "Snowy Hedges",
      "Unkept Hedges",
    ],
    hint: "Run from her, you can outpace her. If she happens to get close, you can blind her with a flashlight to the eyes! Giving you a chance get away"
  },
  {
    id: 44,
    name: "Winter Witch",
    imagePath: "WinterWitch.PNG",
    aka: "White Witch",
    locations: ["Manor", "Snowy Hedges"],
    hint: "You cannot outrun this variant. So best option is to blind and get around a corner/out of her line of sight!"
  },
  {
    id: 46,
    name: "Necreph",
    imagePath: "Necreph.PNG",
    aka: "Trackstar",
    locations: ["Dunes", "Egyptian Temple"],
    hint: "No lights! It reacts and attacks when it sees lights from a lantern or flashlight",
    source: "dlc"
  },
  {
    id: 47,
    name: "Anubis",
    imagePath: "Anubis.PNG",
    aka: "Daddy",
    locations: ["Dunes"],
    hint: "Looking at Anubis slows him down, so running backwards helps keep him away. He cuts turns really well, so when running backwards, it's best to go in a straight line while avoiding his zombie mummies. Using tall dunes and points of interest, then leaping when you reach the top, will de-aggro him for a short time, letting you get distance",
    source: "dlc"
  },
  {
    id: 48,
    name: "Ptahmes",
    imagePath: "Ptahmes.PNG",
    aka: "Locust, Mummy",
    locations: ["Egyptian Temple"],
    hint: "Run and shift to the side, or make turns, when he launches his locusts. He de-aggros quickly when he loses sight of you, or after missing a locust attack",
    source: "dlc"
  },
  {
    id: 49,
    name: "Ouphis",
    imagePath: "Ouphis.PNG",
    aka: "Mimic",
    locations: ["Egyptian Temple"],
    hint: "Keep on moving -- proximity initiates the music/attack, so consistently running or moving away will prevent it from triggering",
    source: "dlc"
  },
  // Add more images here if needed...
];

const Monster = ({ monstersData }) => {
  const [modalImageUrl, setModalImageUrl] = useState(null);
  const [visibleMaps, setVisibleMaps] = useState({});

  const openImageInModal = (imageUrl) => {
    setModalImageUrl(imageUrl);
  };

  const closeModal = () => {
    setModalImageUrl(null);
  };

  const toggleMaps = (id) => {
    setVisibleMaps((prev) => ({
      ...prev,
      [id]: !prev[id],
    }));
  };

  const sourceBadge = {
    dlc: { label: "DLC", className: "bg-purple-900/60 text-purple-200 border border-purple-700/60" },
    story: { label: "Story Mode", className: "bg-gray-700/60 text-gray-200 border border-gray-500/60" },
  };

  const renderItem = (monster) => {
    const badge = sourceBadge[monster.source];
    return (
      <div
        key={monster.name}
        className="bg-gray-900/40 border border-purple-900/40 rounded-lg p-3 hover:border-purple-600/60 transition-colors flex flex-col items-center text-center"
      >
        <img
          className="object-scale-down h-48 cursor-pointer"
          src={require(`../imagesmonster/${monster.imagePath}`)}
          alt={monster.name}
          onClick={() =>
            openImageInModal(require(`../imagesmonster/${monster.imagePath}`))
          }
        />
        <div className="flex items-center gap-2 mt-2">
          <div className="text-lg font-semibold">{monster.name}</div>
          {badge && (
            <span className={`text-xs px-2 py-0.5 rounded-full ${badge.className}`}>
              {badge.label}
            </span>
          )}
        </div>
        <button
          className="mt-2 border rounded-lg px-2 py-1 hover:bg-gray-700"
          onClick={() => toggleMaps(monster.id)}
        >
          Info
        </button>
        {visibleMaps[monster.id] && (
          <div className="mt-2 p-2 bg-gray-800 rounded-lg text-left w-full">
            <div className="text-sm text-gray-300">
              <div className="font-medium">NickNames:</div>
              <div>{monster.aka}</div>
              <div className="mt-2 font-medium">Maps:</div>
              <div className="ml-2">
                {monster.locations.map((location, index) => (
                  <div key={index}>{location}</div>
                ))}
              </div>
              <div className="pt-4 text-green-400">Hint:</div>
              <div>{monster.hint}</div>
            </div>
          </div>
        )}
      </div>
    );
  };

  const renderModal = () => {
    if (!modalImageUrl) return null;

    return (
      <div className="fixed top-0 left-0 w-full h-full flex items-center justify-center bg-gray-900 bg-opacity-80 z-50">
        <div className="relative max-w-lg w-full mx-4">
          <img
            src={modalImageUrl}
            alt="Monster Full Size"
            className="w-full h-auto rounded-lg"
          />
          <button
            onClick={closeModal}
            className="absolute -top-3 -right-3 p-2 bg-red-500 hover:bg-red-600 text-white rounded-full shadow-md"
            aria-label="Close Modal"
          >
            ✕
          </button>
        </div>
      </div>
    );
  };

  const regularMonsters = monstersData.filter((m) => !m.source);
  const dlcMonsters = monstersData.filter((m) => m.source === "dlc");
  const storyMonsters = monstersData.filter((m) => m.source === "story");

  const renderSection = (title, monsters) => {
    if (monsters.length === 0) return null;
    return (
      <Reveal className="mb-6" key={title}>
        <h2 className="font-primary text-xl sm:text-2xl font-bold text-purple-300 mb-3 border-b border-purple-900 pb-1 px-4">
          {title}
        </h2>
        <div className="grid grid-cols-2 sm:grid-cols-3 md:grid-cols-4 lg:grid-cols-6 xl:grid-cols-6 gap-4 px-4">
          {monsters.map((monster) => (
            <div key={monster.id}>{renderItem(monster)}</div>
          ))}
        </div>
      </Reveal>
    );
  };

  return (
    <div className="text-white relative min-h-screen">
      <div
        className="fixed inset-0 -z-10 pointer-events-none"
        style={{
          background:
            "radial-gradient(900px 600px at 82% -8%, rgba(147,51,234,0.16), transparent 60%), " +
            "radial-gradient(1000px 700px at 8% 110%, rgba(88,28,135,0.22), transparent 60%), " +
            "#000",
        }}
      />
      <Nav />
      <div className="text-center font-primary text-2xl sm:text-3xl font-bold my-4">
        MONSTERS
      </div>
      {renderModal()}
      <div className="pb-10">
        {renderSection("Monsters", regularMonsters)}
        {renderSection("DLC", dlcMonsters)}
        {renderSection("Story Mode Only", storyMonsters)}
      </div>
    </div>
  );
};

export default function MonsterPage() {
  return <Monster monstersData={monstersData} />;
}
